<template>
  <WhiteIQOS
    :enabled="true"
    :hideBody="true"
    :title="$t('phone_confirmation_panel.title')"
    :subtitle="$t('phone_confirmation_panel.subtitle')"
  >
    <template #actions>
      <BaseToggleSwitcher
        size="lg"
        fillBg="background-success-default"
        disabledBg="background-base-inverse-primary"
        :value="confirmationEnabled"
        @input="(v) => (confirmationEnabled = !confirmationEnabled)"
      ></BaseToggleSwitcher>
    </template>

    <template #footer>
      <div class="sms-footer">
        <div class="gap-column-1xs">
          <BaseIcon
            icon="alert-circle"
            size="sm"
            class="qrw-text-content-warning-primary"
          />
          <div class="qrw-paragraph-sm qrw-text-content-warning-primary">
            {{ $t("phone_confirmation_panel.warning") }}
          </div>
        </div>

        <BasePushButton
          variant="outlined"
          size="sm"
          textColor="content-base-primary"
          borderColor="border-base-secondary"
          class="more-link qrw-text-content-link qrw-label-md bold gap-column-1xs"
          @click="$router.push('/sms_settings')"
        >
          {{ $t("phone_confirmation_panel.more") }}
        </BasePushButton>
      </div>
    </template>
  </WhiteIQOS>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    confirmationEnabled: {
      get() {
        return this.$store.state.cafe.reserve.use_phone_verification;
      },
      set(v) {
        this.$store.commit("setReserveUsePhoneVerification", v);
        this.$store.dispatch("saveCafe");
      },
    },
  },
};
</script>

<style scoped>
.sms-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  box-sizing: border-box;
  background: var(--qrw-background-warning-primary);
  column-gap: 4px;
}

.more-link {
  cursor: pointer;
  align-items: center;
}
</style>
